var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// Valid Eurostar search
function eurostar(outbound,inbound) {
     // Is the return journey after the last operational Eurostar date?
    if (inbound.getTime() > eurostardate.getTime()) { warning(literal('search.sorry-max-date', {maxDate: moment(eurostardate).format('Do MMMM YYYY')}),literal('search.no-eurostar')); GA.sendEvent('Alert','Search','Eurostar Out of Range'); return false; }
    // Indirect trains are only bookable within 90 days, or can be manually overriden by SNCF releasing blocks of inventory
    // var ninetydays = addDays(new Date(),90); (Archived)
    var indirect = eurostarindirect;
    // Is the indirect train available on the return date?
    if (inbound.getTime() <= indirect.getTime()) { return true; }
    // Is the indirect train not available on the outbound date, and no direct train is available either?
    if ((outbound.getTime() > indirect.getTime()) && (!direct(outbound))) { directTrain(outbound); return false; }
    // Is the indirect train not available on the return date, and no direct train is available either?
    if ((inbound.getTime() > indirect.getTime()) && (!direct(inbound))) { directTrain(inbound); return false; }
    // Otherwise valid
    return true;
}

// Determine if a direct train is running
function direct(date) {
    // No direct trains are running between excludeDateFrom - excludeDateTo
    if (isWinterExclusion(date)){ date.isDirectBlockout = true; return false; }

    // Otherwise is the date an active exception date (e.g. during school holidays)
    var active = eurostaractive.split(',')
    for (i = 0; i < active.length; i++) { if (date.getTime() == new Date(active[i]).getTime()) { return true; }; }
    // Is this date not a Tuesday, Thursday or Saturday?
    var day = date.getDay() // Sunday == 0

    var eurostarAvailability = getEurostarAvailability(date);
    if (eurostarAvailability) {
        return eurostarAvailability.daysAvailable.includes(day);
    }
    if (day!=2 && day!=4 && day!=6) { return true; }

    // Otherwise no direct trains
    return false;
}

// Show warning message regarding direct trains
function directTrain(date) {
    var excludeDateFrom = $('#quick-quote').attr('data-eurostar-direct-start') || (typeof eurostarDirectStart !== "undefined" && eurostarDirectStart);
    var excludeDateTo = $('#quick-quote').attr('data-eurostar-direct-end') || (typeof eurostarDirectEnd !== "undefined" && eurostarDirectEnd);
    var indirectUpTo;
    // Setup indirect messaging
    if (eurostarindirectrollingperiod) {
        indirectUpTo = literal('search.indirectRollingPeriod', {rollingPeriod: moment.duration(eurostarindirectrollingperiod, 'days').humanize()});
    } else {
        indirectUpTo = literal('search.indirectUpTo', {indirectDate: moment(eurostarindirect).format('Do MMMM YYYY')});
    }
    var indirectMsg = literal('search.indirect', {upToMessage: indirectUpTo });
    // check if this date is a direct trains blockout date
    if (date.isDirectBlockout) {
        var excludeFrom = moment(excludeDateFrom, "DD/MM/YYYY").isBefore(new Date()) ? moment(new Date()) : moment(excludeDateFrom, "DD/MM/YYYY");
        warning(literal('search.no-direct-train', { excludeFrom: excludeFrom.format('Do MMMM YYYY'), excludeTo: moment(excludeDateTo, "DD/MM/YYYY").format('Do MMMM YYYY') }), indirectMsg)
        GA.sendEvent( 'Alert', 'Search', 'No Eurostar Timetable');
    }
    else {
        var eurostarAvailability = getEurostarAvailability(date);
        var indirectMsgBeginning;

        if (!eurostarAvailability) {
            indirectMsgBeginning = literal('search.no-train-tuesday-message');
        } else if (eurostarAvailability.daysAvailable.length === 0) {
            var nextAvailableDay = moment(eurostarAvailability.end).add(1,'day').format('dddd Do MMMM YYYY');
            indirectMsgBeginning = literal('search.no-trains-before-date', {nextDate: nextAvailableDay});
        } else {
            indirectMsgBeginning = literal('search.trains-certain-days', {days: daysNumberToNames(eurostarAvailability.daysAvailable)});
        }
        warning(literal('search.no-trains', { noDate: moment(date).format('dddd Do MMMM YYYY') }), indirectMsgBeginning + indirectMsg)
        GA.sendEvent( 'Alert', 'Search', 'Eurostar Unavailable');
    }
}

// Determine if supplied date falls within winter direct train exclusion dates, added to markup from sever side script via data attributes
function isWinterExclusion(date) {
    var excludeDateFrom = $('#quick-quote').attr('data-eurostar-direct-start') || (typeof eurostarDirectStart !== "undefined" && eurostarDirectStart);
    var excludeDateTo = $('#quick-quote').attr('data-eurostar-direct-end') || (typeof eurostarDirectEnd !== "undefined" && eurostarDirectEnd);
    if (excludeDateFrom != null && excludeDateTo != null) {
        if (moment(date).isAfter(moment(excludeDateFrom, "DD/MM/YYYY")) &&
            moment(date).isSameOrBefore(moment(excludeDateTo, "DD/MM/YYYY"))) {
            return true;
        }
    }
    return false;
}

function getEurostarAvailability(date) {
    var eurostarAvailability;
    if (typeof directEurostarAvailability !== 'undefined') {
        directEurostarAvailability.forEach( function(range) {
            if (moment(date).isBetween(range.start, range.end, undefined, '[]') ) {
                eurostarAvailability = range;
            }
        })
    }

    return eurostarAvailability;
}


function daysNumberToNames(numbers) {
    var names = numbers.map( function(number) {
        return dayNames[number]
    } )
    return names.join(', ').replace(/, ([^,]*)$/, ' and $1');
}
